import { Contributions } from '@upright/common/model/output/scores/drilldowns/types';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { useQuery } from '@tanstack/react-query';

export function useCompanyDrilldownContributions(resultId: string | undefined) {
  return useQuery({
    queryKey: ['queryCompanyDrilldownContributions', resultId],

    queryFn: async () => {
      return await fetchOrThrow<Contributions>(`/company/${String(resultId)}/drilldown-contributions`);
    },

    enabled: resultId !== undefined,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
